<div cdkDropList
     [cdkDropListData]="categorias"
     (cdkDropListDropped)="onCategoriaDrop($event)"
     class="categorias-drop-list">

  <div *ngFor="let categoria of categorias; trackBy: trackByCategoria"
       cdkDrag
       [cdkDragData]="categoria"
       class="categoria-drag-item">

    <!-- Drag Preview -->
    <div *cdkDragPreview class="categoria-drag-preview">
      <i class="pi pi-ellipsis-v"></i>
      <i class="pi pi-ellipsis-v"></i>
      <span class="ml-2">{{ categoria.nome }}</span>
    </div>

    <!-- Drag Placeholder -->
    <div *cdkDragPlaceholder class="categoria-drag-placeholder"></div>

    <p-accordion [multiple]="true">
      <p-accordionTab>
        <!-- Header customizado da categoria -->
        <ng-template pTemplate="header">
          <div class="categoria-header" (click)="$event.stopPropagation()">
            <!-- Drag Handle -->
            <div cdkDragHandle class="drag-handle" aria-label="Arrastar categoria">
              <i class="pi pi-ellipsis-v"></i>
              <i class="pi pi-ellipsis-v"></i>
            </div>

            <!-- Nome da categoria (modo visualizacao ou edicao) -->
            <div class="categoria-nome-container" *ngIf="editandoCategoriaId !== categoria.id">
              <span class="categoria-nome">{{ categoria.nome }}</span>
            </div>
            <div class="categoria-nome-container" *ngIf="editandoCategoriaId === categoria.id" (click)="$event.stopPropagation()">
              <input pInputText
                     [(ngModel)]="editandoCategoriaNome"
                     class="categoria-nome-input"
                     (keydown.enter)="confirmarEdicaoCategoria(categoria)"
                     (keydown.escape)="cancelarEdicaoCategoria()" />
              <button pButton type="button" icon="pi pi-check"
                      class="p-button-rounded p-button-text p-button-success p-button-sm"
                      (click)="confirmarEdicaoCategoria(categoria)"></button>
              <button pButton type="button" icon="pi pi-times"
                      class="p-button-rounded p-button-text p-button-danger p-button-sm"
                      (click)="cancelarEdicaoCategoria()"></button>
            </div>

            <!-- Contador de produtos -->
            <p-badge [value]="getContadorProdutos(categoria)" severity="info" styleClass="ml-auto mr-2"></p-badge>

            <!-- Botao + Produto -->
            <button pButton
                    type="button"
                    icon="pi pi-plus"
                    [label]="texts.novo_produto"
                    class="p-button-text p-button-sm mr-1"
                    (click)="$event.stopPropagation(); novoProduto.emit(categoria.id!)">
            </button>

            <!-- Menu 3 pontos -->
            <button pButton
                    type="button"
                    icon="pi pi-ellipsis-h"
                    class="p-button-rounded p-button-text p-button-sm"
                    (click)="$event.stopPropagation(); buildCategoriaMenu(categoria); catMenu.toggle($event)">
            </button>
            <p-menu #catMenu [popup]="true" [model]="categoriaMenuItems" appendTo="body"></p-menu>
          </div>
        </ng-template>

        <!-- Conteudo: Lista de produtos com drag-and-drop -->
        <div class="produtos-container"
             cdkDropList
             [cdkDropListData]="categoria.produtos"
             (cdkDropListDropped)="onProdutoDrop($event, categoria.id!)">

          <!-- Produtos filtrados -->
          <div *ngFor="let produto of filtrarProdutos(categoria.produtos); trackBy: trackByProduto"
               cdkDrag
               [cdkDragData]="produto"
               class="produto-drag-item">

            <div *cdkDragPlaceholder class="produto-drag-placeholder"></div>

            <app-cardapio-minishop-produto-item
              [produto]="produto"
              [moedaSimbolo]="moedaSimbolo"
              [moedaLocal]="moedaLocal"
              (editar)="editarProduto.emit($event)"
              (toggleVisibilidade)="toggleVisibilidadeProduto.emit($event)"
              (excluir)="excluirProduto.emit($event)">
            </app-cardapio-minishop-produto-item>
          </div>

          <!-- Empty state de produtos -->
          <div *ngIf="filtrarProdutos(categoria.produtos).length === 0" class="produtos-empty">
            <i class="pi pi-inbox"></i>
            <span>{{ texts.sem_produtos }}</span>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
